angular.module('unergie.main')
.controller('potExplainCtrl', ($scope, $uibModalInstance, BoFeaturesService, NgTableParams, ApiUser, DataAccess, AlertManager, ErrorCatcher, account) => {
    $scope.isFeatureOn = BoFeaturesService.isFeatureOn
    $scope.potExplain = {}
    $scope.tables = {}

    let modified = false

    $scope.close = () => {
        $uibModalInstance.close(modified)
    }

    $scope.cancelInvestFields = {
        force: {
            hidden: (template) => template.transaction_type !== 55,
            label: 'Forcer',
            type: 'checkbox',
        },
    }

    $scope.cancelInvestment = (creditTransaction) => {
        console.log(`creditTransaction`, creditTransaction)
        creditTransaction.cancelling = true
        return DataAccess.cancelCreditTransactionInvestment({ id: creditTransaction.id, force: !!creditTransaction.force }).$promise.then(() => {
            AlertManager.success(`Investissement annulé`)
            modified = true
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            creditTransaction.cancelling = false
        })
    }

    $scope.refresh = () => {
        return ApiUser.potExplaination({ id_account: account.id }).$promise.then((potExplainResult) => {
            $scope.potExplain = potExplainResult
            const toNgTable = (predicate) => new NgTableParams({ sorting: { date: 'desc' } }, { dataset: _.filter(potExplainResult.elems, predicate) })
            $scope.tables = {
                potExplainHistory:
                    toNgTable(() => true),
                consumptionGain:
                    toNgTable((e) => [10, 11].indexOf(e.transaction_type) > -1),
                exceptionalGain:
                    toNgTable((e) => (12 <= e.transaction_type && e.transaction_type <= 19)),
                estimatedGain:
                    toNgTable((e) => [20, 21].indexOf(e.transaction_type) > -1),
                usedPot:
                    toNgTable((e) => (e.transaction_type >= 50)),
            }
        })
    }

    const activate = () => {
        $scope.refresh()
    }

    activate()
})
